import React from "react";

export default function TopToggle({ value, onChange }) {
  return (
    <div className="relative w-48 h-10 flex border border-primary-500 rounded overflow-hidden cursor-pointer select-none">
      {/* Highlight */}
      <div
        className="absolute top-0 h-full w-1/2 bg-primary-500 transition-all duration-300"
        style={{ left: value === "top10" ? "0%" : "50%" }}
      />
      {/* Top 10 */}
      <button
        className={`flex-1 uppercase tracking-widest z-10 transition-colors duration-300 ${
          value === "top10"
            ? "text-black font-semibold"
            : "text-white hover:text-gray-300"
        }`}
        onClick={() => onChange("top10")}
      >
        Top 10
      </button>
      {/* Alle */}
      <button
        className={`flex-1 uppercase tracking-widest z-10 transition-colors duration-300 ${
          value === "all"
            ? "text-black font-semibold"
            : "text-white hover:text-gray-300"
        }`}
        onClick={() => onChange("all")}
      >
        Alle
      </button>
    </div>
  );
}
